import { render } from "./PantryDetailDataView.vue?vue&type=template&id=54b52d8e&ts=true"
import script from "./PantryDetailDataView.vue?vue&type=script&lang=ts"
export * from "./PantryDetailDataView.vue?vue&type=script&lang=ts"

import "./PantryDetailDataView.vue?vue&type=style&index=0&id=54b52d8e&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__